import type { IContainer } from '../../interface/container';
import cacheInst from '../impl/cache.bind';
import {
    bindMediaCacheController,
    injectMediaCacheController,
    unbindMediaCacheController,
} from '../interface/bind';

function bind(container: IContainer) {
    bindMediaCacheController(cacheInst(container), container);
}

function unbind(container: IContainer) {
    unbindMediaCacheController(container);
}

function expose(srcContainer: IContainer, dstContainer: IContainer) {
    bindMediaCacheController(injectMediaCacheController(srcContainer), dstContainer);
}

const module = {
    bind,
    unbind,
    expose,
};

export default module;
